import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import LanguageSelect from '../LanguageSelect';
const Footer = () => {
    const { t, i18n } = useTranslation();
    return (
        <footer className="pt-5">
            {/* <div className="container">
                <div className="row">
                    <div className="col-md-2 col-sm-6 col-6">
                        <h5 className="tittle-footer">{t('Menu.quick_links')}</h5>
                        <ul>
                            <li><Link className='nav-link' href="#">{t('Menu.about')}</Link></li>
                            <li><Link className='nav-link' href="#">{t('Menu.leadership')}</Link></li>
                        </ul>
                    </div>
                    <div className="col-md-2 col-sm-6 col-6">
                        <h5 className="tittle-footer">{t('Menu.careers')}</h5>
                        <ul>
                            <li><Link className='nav-link' href="#">{t('Menu.contact')}</Link></li>
                            <li><Link className='nav-link' href="#">{t('Menu.speak_up')}</Link></li>
                        </ul>
                    </div>
                    <div className="col-md-2 col-sm-6 col-6">
                        <h5 className="tittle-footer">{t('Menu.about_website')}</h5>
                        <ul>
                            <li><Link className='nav-link' href="#">{t('Menu.our_history')}</Link></li>
                            <li> <Link className='nav-link' href="#">{t('Menu.leadership')}</Link></li>
                            <li><Link className='nav-link' href="#">{t('Menu.certificate_and_awards')}</Link></li>
                            <li><Link className='nav-link' href="#">{t('Menu.savola_corporate')}</Link></li>
                        </ul>
                    </div>
                    <div className="col-md-2 col-sm-6 col-6">
                        <h5 className="tittle-footer">{t('Menu.follow_us_social')}</h5>
                        <ul>
                            <li> <Link className='nav-link' href="#">{t('Social.facebook')}</Link></li>
                            <li> <Link className='nav-link' href="#">{t('Social.instagram')}</Link></li>
                            <li><Link className='nav-link' href="#">{t('Social.youtube')}</Link></li>
                            <li><Link className='nav-link' href="#">{t('Social.twitter')}</Link></li>
                            <li> <Link className='nav-link' href="#">{t('Social.linkedin')}</Link></li>
                        </ul>
                    </div>
                    <div className="col-md-2 col-sm-6 col-6">
                        <h5 className="tittle-footer">{t('Menu.shop_with_us')}</h5>
                        <ul>
                            <li> <Link className='nav-link' href="#">{t('Menu.panda_click')}</Link></li>
                        </ul>
                    </div>
                    <div className="col-md-2 col-sm-6 col-6">
                        <h5 className="tittle-footer">{t('Language')}</h5>
                        <ul>
                            <li><LanguageSelect type="A" /></li>
                        </ul>
                    </div>
                </div>
            </div> */}
            <div className="footer-part py-4 text-center text-white">
                <div> {t('Copyright')}</div>
            </div>
        </footer>
    )
}

export default Footer